import { render, staticRenderFns } from "./OddEven.vue?vue&type=template&id=234e9c42&"
import script from "./OddEven.vue?vue&type=script&lang=js&"
export * from "./OddEven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports